import partition from 'lodash/partition';

const getCutLineData = (players, cutLine) => {
    return partition(players, (obj) => {
        let displayValue = null;
        if (obj.position.displayValue) {
            displayValue = isSpecialStatus(obj) ? obj.position.displayValue : Number.parseInt(obj.position.displayValue.replace('T', ''), 10);
        } else {
            displayValue = '';
        }

        if (Number.isNaN(parseInt(displayValue, 10)) || displayValue === '') {
            if (!isSpecialStatus(obj)) {
                return true;
            }

            if (obj.position.sortValue > cutLine) {
                return true;
            }
        }

        return displayValue > cutLine;
    });
};

const getStatusData = (players) => {
    return partition(players, (player) => {
        return player.status !== 1;
    });
};

const isSpecialStatus = (player) => {
    const specialStatuses = ['WD', 'RTD', 'DSQ', 'DQ'];
    return specialStatuses.includes(player.position.displayValue);
};

export const splitPlayers = (cutLineState, scoringPlayersCopy, cutLine = null) => {
    let playersAll = [];

    if (cutLineState) {
        playersAll = getCutLineData(scoringPlayersCopy, cutLine);
    } else {
        playersAll = getStatusData(scoringPlayersCopy);
    }

    return playersAll;
};
